import { useTranslation } from 'react-i18next';
import TableCell from '@mui/material/TableCell';
import Box from '@mui/material/Box';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const TableCellWithCopy = ({ children, copyText, ...props }) => {
  const { t } = useTranslation();
  const copyTextToClipboard = (text) =>{
    navigator.clipboard.writeText(text)
      .then(() => {
        console.log('Text successfully copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
      });
  }
  return (
    <TableCell 
      onClick={() => copyTextToClipboard(copyText)}
      sx={{
        '& svg': {
          md: {
            opacity: 0,
            transition: 'opacity 0.2s ease-in-out',
          }
        },
        '&:hover': {
          '& svg': {
            md: {
              opacity: 1,
            }
          },
        }
        
      }}
      { ...props }
    >
      <Box 
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        { children }
        <ContentCopyIcon 
          color="text.secondary"
          title={t('copy')}
          fontSize="small"
          sx={{
            cursor: 'pointer',
          }}
        />
      </Box>
        
    </TableCell>
  )
}

export default TableCellWithCopy;